
import { getInstagramStatistic } from "@/api/accounts";
import { getTiktokStatistic } from "@/api/accounts";
const state = {
  tiktok: {
    likes: 0,
    views: 0,
    followers: 0,
    minLikes: 0,
    minFollowers: 0,
    minViews: 0,
  },
  instagram: {
    likes: 0,
    comments: 0,
    followers: 0,
    minLikes: 0,
    minFollowers: 0,
    minComments: 0,
  },
};

const mutations = {
  SET_INSTAGRAM_SCORES: (state, instagram) => {
    state.instagram = instagram;
  },
  SET_TIKTOK_SCORES: (state, tiktok) => {
    state.tiktok = tiktok;
  },
};

const actions = {
  async getInstagramStatistic({ commit }) {
    return new Promise((resolve, reject) => {
      getInstagramStatistic().then(response => {
       commit('SET_INSTAGRAM_SCORES', {
          likes: response.likesCount,
          comments: response.commentsCount,
          followers: response.followersCount,
          minLikes:  response.minLikesCount,
          minFollowers: response.minFollowersCount,
          minComments:  response.minCommentsCount,
       });
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  async getTikTokStatistic({ commit }) {
    return new Promise((resolve, reject) => {
      getTiktokStatistic().then(response => {
        commit('SET_TIKTOK_SCORES', {
          likes: response.likesCount,
          views: response.viewsCount,
          followers: response.followersCount,
          minLikes:  response.minLikesCount,
          minFollowers: response.minFollowersCount,
          minViews:  response.minViewsCount,
        });
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
